export function selectVersion(instanceVersionMap, versionId) {
  const versionIds = Object.keys(instanceVersionMap);
  const useVersion = versionIds.indexOf(versionId) > -1 ? versionId : versionIds[0];
  return instanceVersionMap[useVersion];
}
